// extracted by mini-css-extract-plugin
export default {"maintenanceOrder":"styles_maintenanceOrder__wqck5","success":"styles_success__2XO-U","loading":"styles_loading__lMqzB","error":"styles_error__cECZl"};